import { useState, useEffect } from "react";
import FormSection from "../ui/FormSection";
import FormInput from "../ui/FormInput";
import Button from "../ui/Button";
import EditableTable from "../ui/EditableTable";
import StatusBadge from "../ui/StatusBadge";
import InvitationController from "@/network/controllers/invitation.controller";
import State, { STATE, CurrentEntityState, CurrentStudyState } from "@state";

export default function RoleManagement({
  study = {},
  onUpdateStudy,
  roleManagementData = {},
  availableSites = [],
}) {
  const [studyManagers, setStudyManagers] = useState(
    roleManagementData.study_manager ? [roleManagementData.study_manager] : []
  );
  const [investigators, setInvestigators] = useState(
    roleManagementData.investigators || []
  );
  const [sites, setSites] = useState(
    availableSites.map((site) => ({
      id: site.site_id,
      siteName: site.site_name,
    }))
  );

 
  const [newManager, setNewManager] = useState({
    name: "",
    contactName: "",
    email: "",
  });

  const [newInvestigator, setNewInvestigator] = useState({
    name: "",
    email: "",
    phone: "",
    site: "",
  });

  const [isSendingManagerInvitation, setIsSendingManagerInvitation] =
    useState(false);
  const [managerInvitationError, setManagerInvitationError] = useState(null);
  const [isSendingInvestigatorInvitation, setIsSendingInvestigatorInvitation] =
    useState(false);
  const [investigatorInvitationError, setInvestigatorInvitationError] =
    useState(null);
    const normalizeStatus = (s) => {
      if (s === "confirmed") return "active";
      return s; 
    };

useEffect(() => {
  console.log("[RoleManagement] STATE:", STATE);
  console.log("[RoleManagement] CRO_MANAGERS:", STATE?.CRO_MANAGERS);
  console.log("[RoleManagement] STUDY_MANAGERS:", STATE?.STUDY_MANAGERS);
  console.log("[RoleManagement] CURRENT_ENTITY_DATA:", STATE?.CURRENT_ENTITY_DATA);
}, [STATE]);

const currentEntity = STATE[CurrentEntityState.CURRENT_ENTITY_DATA] || {};


const entityNameFromState =
  currentEntity?.entity_data?.contact?.entityName ||
  currentEntity?.entity_data?.entityName ||
  currentEntity?.entityName ||
  "N/A";

useEffect(() => {
  console.log("[RoleManagement] CURRENT_ENTITY_DATA:", currentEntity);
  console.log("[RoleManagement] entity_data:", currentEntity?.entity_data);
  console.log(
    "[RoleManagement] entity_data (stringified):",
    JSON.stringify(currentEntity?.entity_data, null, 2)
  );
  console.log("[RoleManagement] entityName resolved:", entityNameFromState);
}, [currentEntity, entityNameFromState]);


  useEffect(() => {
    // — STUDY MANAGERS —
    const managers = [];

    // 1) OWNER
    if (roleManagementData.study_manager) {
      if (roleManagementData.study_manager) {
        managers.push({
          id: "study-owner",
        user_first_name: currentEntity?.entity_data?.contact?.entityName || "N/A",
        user_last_name: "",
        entity_name: `${roleManagementData.study_manager.firstname || ""} ${roleManagementData.study_manager.lastname || ""}`,
          user_email: roleManagementData.study_manager.email,
          invitation_status: "active",
        });
      }
    }

    // INVITATION CRO
    (roleManagementData.cro_invitations || []).forEach((inv) => {
     
    
      managers.push({
        id: inv.id,
        firstname: inv.firstname,
        lastname: inv.lastname,
        user_first_name: inv.firstname, 
        user_last_name: inv.lastname,  
        user_email: inv.email,
        entity_name: inv.contact_name || "",
        invitation_status: normalizeStatus(inv.invitation_status),
      });
    });

    setStudyManagers(managers);

    // — INVESTIGATORS —
    const invs = (roleManagementData.investigator_invitations || []).map((inv) => {
      const firstName = inv.firstname || "";
      const lastName = inv.lastname || "";
      return {
        id: inv.id,
        investigator_first_name: firstName,
        investigator_last_name: lastName,
        investigator_full_name: `${firstName} ${lastName}`.trim(),
        investigator_email: inv.email,
        investigator_phone_number: inv.phone_number || "",
        site_name: inv.site_name || "",
        invitation_status: normalizeStatus(inv.invitation_status),
      };
    });

    setInvestigators(invs);
  }, [roleManagementData]);
  useEffect(() => {
    if (availableSites) {
      setSites(
        availableSites.map((site) => ({
          id: site.site_id,
          siteName: site.site_name,
        }))
      );
    }
  }, [availableSites]);

  // Study Managers columns
  const studyManagerColumns = [
    {
      key: "user_first_name",
      header: "Study manager name",
      width: "33%",
      render: (item) => `${item.user_first_name} ${item.user_last_name}`,
    },
    { key: "entity_name", header: "Contact name", width: "33%" },
    { key: "user_email", header: "Email address", width: "34%" },
  ];

  // Investigators columns
  const investigatorColumns = [
    {
      key: "investigator_full_name",
  header: "Investigator name",
  width: "25%",
      render: (item) =>
        `${item.investigator_first_name} ${item.investigator_last_name}`,
    },
    { key: "investigator_email", header: "Email address", width: "25%" },
    { key: "investigator_phone_number", header: "Phone number", width: "25%" },
    { key: "site_name", header: "Assigned site", width: "25%" },
  ];

  // Handle input change for new manager
  const handleManagerInputChange = (e) => {
    const { name, value } = e.target;
    setNewManager((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle input change for new investigator
  const handleInvestigatorInputChange = (e) => {
    const { name, value } = e.target;
    setNewInvestigator((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleConfirmInvitation = async (id, type) => {
    try {
      const res = await InvitationController.confirmInvitation(id);
      console.log(`confirmInvitation (${type}) returned:`, res);
      if (res.success) {
        if (type === "manager") {
          setStudyManagers((ms) =>
            ms.map((m) =>
              m.id === id ? { ...m, invitation_status: "active" } : m
            )
          );
        } else {
          setInvestigators((iv) =>
            iv.map((i) =>
              i.id === id ? { ...i, invitation_status: "active" } : i
            )
          );
        }
        alert("Invitation confirmed!");
      } else {
        alert(`Error: ${res.message}`);
      }
    } catch (err) {
      console.error("Error while confirmInvitation:", err);
      alert("Error while confirming invitation");
    }
  };

  // Add new study manager (questa logica dovrà essere integrata con il backend)
  const handleAddManager = async () => {
    if (!newManager.name || !newManager.contactName || !newManager.email) {
      alert("Please fill in all required fields");
      return;
    }

    setIsSendingManagerInvitation(true);
    setManagerInvitationError(null);

    const entityId = STATE[CurrentEntityState.CURRENT_ENTITY_ID];

    try {
      const response = await InvitationController.sendProtectedInvitation({
        study_id: study.id,    
        email: newManager.email,
        firstname: newManager.name.split(" ")[0],
        lastname: newManager.name.split(" ")[1] || "",
        contact_name: newManager.contactName,
        invitation_type: "join_cro",
        entity_id: entityId,
      });

      if (response.success) {
        const newManagerWithId = {
          id: response.id,
          user_first_name: newManager.name.split(" ")[0],
          user_last_name: newManager.name.split(" ")[1] || "",
          entity_name: newManager.contactName,
          user_email: newManager.email,
          invitation_status: "pending",
        };
        const updatedManagers = [...studyManagers, newManagerWithId];
        setStudyManagers(updatedManagers);
        setNewManager({
          name: "",
          contactName: "",
          email: "",
        });
        if (onUpdateStudy) {
          onUpdateStudy({
            ...study,
            studyManagers: updatedManagers,
          });
        }
        alert("Study Manager invitation sent successfully!");
      } else {
        setManagerInvitationError(
          response.message || "Failed to send invitation."
        );
        alert(
          `Error sending invitation: ${response.message || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error("Error sending manager invitation:", error);
      setManagerInvitationError("An unexpected error occurred.");
      alert("An unexpected error occurred while sending the invitation.");
    } finally {
      setIsSendingManagerInvitation(false);
    }
  };

  // Add new investigator (questa logica dovrà essere integrata con il backend)
  const handleAddInvestigator = async () => {
    if (
      !newInvestigator.name ||
      !newInvestigator.email ||
      !newInvestigator.phone ||
      !newInvestigator.site
    ) {
      alert("Please fill in all required fields");
      return;
    }

    setIsSendingInvestigatorInvitation(true);
    setInvestigatorInvitationError(null);

    try {
      const selectedSite = sites.find(
        (site) => site.id === newInvestigator.site
      );
      const siteName = selectedSite ? selectedSite.siteName : "";

      console.log(
        "Valeur de newInvestigator.phone avant l envoie:",
        newInvestigator.phone
      );

      const entityId = STATE[CurrentEntityState.CURRENT_ENTITY_ID];


  
      const response = await InvitationController.sendProtectedInvitation({
        study_id: study.id,    
        email: newInvestigator.email,
        firstname: newInvestigator.name.split(" ")[0],
        lastname: newInvestigator.name.split(" ")[1] || "",
        invitation_type: "investigator",
        phone_number: newInvestigator.phone,
        site_id: newInvestigator.site,
        entity_id: entityId,
      });

      console.log('=== response === RoleManagements.jsx === key: 173548 ===');
      console.dir(response, { depth: null, colors: true })
      console.log('=================================');

      if (response?.success!==false) {
        const newInvestigatorWithId = {
          id: response.id,
          investigator_first_name: newInvestigator.name.split(" ")[0],
          investigator_last_name: newInvestigator.name.split(" ")[1] || "",
          investigator_email: newInvestigator.email,
          investigator_phone_number: newInvestigator.phone,
          site_id: newInvestigator.site,
          site_name: siteName,
          invitation_status: normalizeStatus("pending"),
        };

        const updatedInvestigators = [...investigators, newInvestigatorWithId];
        setInvestigators(updatedInvestigators);
        setNewInvestigator({
          name: "",
          email: "",
          phone: "",
          site: "",
        });
        if (onUpdateStudy) {
          onUpdateStudy({
            ...study,
            investigators: updatedInvestigators,
          });
        }
        alert("Investigator invitation sent successfully!");
      } else {
        setInvestigatorInvitationError(
          response.message || "Failed to send invitation."
        );
        alert(
          `Error sending invitation: ${response.message || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error("Error sending investigator invitation:", error);
      setInvestigatorInvitationError("An unexpected error occurred.");
      alert("An unexpected error occurred while sending the invitation.");
    } finally {
      setIsSendingInvestigatorInvitation(false);
    }
  };

  // Handle edit study manager 
  const handleEditManager = (updatedManager) => {
    const updatedManagers = studyManagers.map((manager) =>
      manager.id === updatedManager.id ? updatedManager : manager
    );
    setStudyManagers(updatedManagers);
    if (onUpdateStudy) {
      onUpdateStudy({
        ...study,
        studyManagers: updatedManagers,
      });
    }
  };

  // Handle delete study manager 
  const handleDeleteManager = async (manager) => {
    try {
      const res = await InvitationController.cancelInvitation(manager.id);
      if (res.success) {
        const updatedManagers = studyManagers.filter((m) => m.id !== manager.id);
        setStudyManagers(updatedManagers);
        if (onUpdateStudy) {
          onUpdateStudy({
            ...study,
            studyManagers: updatedManagers,
          });
        }
        alert("Invitation cancelled successfully.");
      } else {
        alert(`Error: ${res.message}`);
      }
    } catch (error) {
      console.error("Error cancelling study manager invitation:", error);
      alert("An unexpected error occurred while cancelling the invitation.");
    }
  };

  // Handle reorder study managers
  const handleReorderManagers = (oldIndex, newIndex) => {
    const updatedManagers = [...studyManagers];
    const [movedItem] = updatedManagers.splice(oldIndex, 1);
    updatedManagers.splice(newIndex, 0, movedItem);
    setStudyManagers(updatedManagers);
    if (onUpdateStudy) {
      onUpdateStudy({
        ...study,
        studyManagers: updatedManagers,
      });
    }
  };

  // Handle edit investigator 
  const handleEditInvestigator = (updatedInvestigator) => {
    const updatedInvestigators = investigators.map((investigator) =>
      investigator.id === updatedInvestigator.id
        ? updatedInvestigator
        : investigator
    );
    setInvestigators(updatedInvestigators);
    if (onUpdateStudy) {
      onUpdateStudy({
        ...study,
        investigators: updatedInvestigators,
      });
    }
  };

  // Handle delete investigator 
  const handleDeleteInvestigator = async (investigator) => {
    try {
      const res = await InvitationController.cancelInvitation(investigator.id);
      if (res.success) {
        const updatedInvestigators = investigators.filter(
          (i) => i.id !== investigator.id
        );
        setInvestigators(updatedInvestigators);
        if (onUpdateStudy) {
          onUpdateStudy({
            ...study,
            investigators: updatedInvestigators,
          });
        }
        alert("Invitation cancelled successfully.");
      } else {
        alert(`Error: ${res.message}`);
      }
    } catch (error) {
      console.error("Error cancelling investigator invitation:", error);
      alert("An unexpected error occurred while cancelling the invitation.");
    }
  };

  // Handle reorder investigators
  const handleReorderInvestigators = (oldIndex, newIndex) => {
    const updatedInvestigators = [...investigators];
    const [movedItem] = updatedInvestigators.splice(oldIndex, 1);
    updatedInvestigators.splice(newIndex, 0, movedItem);
    setInvestigators(updatedInvestigators);
    if (onUpdateStudy) {
      onUpdateStudy({
        ...study,
        investigators: updatedInvestigators,
      });
    }
  };

  const renderManagerCell = (key, item, value, onChange, isEditMode) => {
    if (key === "user_first_name") {
      return (
        <span>{`${item.user_first_name || ""} ${item.user_last_name || ""}`}</span>
      );
    }
  
    if (isEditMode) {
      return (
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange && onChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
        />
      );
    }
  
    return <span>{value}</span>;
  };
  // Custom cell renderer for investigators
  const renderInvestigatorCell = (key, item, value, onChange, isEditMode) => {
    if (key === "site_name" && isEditMode) {
      const currentSiteId =
        sites.find((site) => site.siteName === value)?.id || "";
      return (
        <select
          value={currentSiteId}
          onChange={(e) => {
            const selectedId = e.target.value;
            const selectedSite = sites.find((site) => site.id === selectedId);
            onChange(selectedSite ? selectedSite.siteName : "");
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
        >
          <option value="">Select</option>
          {sites.map((site) => (
            <option key={site.id} value={site.id}>
              {site.siteName}
            </option>
          ))}
        </select>
      );
    }
    if (isEditMode) {
      return (
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange && onChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
        />
      );
    }
    return <span>{value}</span>;
  };

  // Custom render function for manager actions
  const renderManagerActions = (item, onShowDeleteModal, onEdit) => {
    let statusElement;
    if (
      item.invitation_status === "pending" ||
      item.invitation_status === "sent"
    ) {
      statusElement = <StatusBadge type="invited">Invited</StatusBadge>;
    } else {
      statusElement = <StatusBadge type="active">Active</StatusBadge>;
    }
  
    return (
      <div className="flex items-center space-x-2 justify-end">
        {statusElement}
        <button
          onClick={() => onShowDeleteModal(item)}
          className="text-gray-700 hover:text-gray-900 cursor-pointer"
          aria-label="Delete"
        >
          <img
            src="/icons/study/Bin.svg"
            alt="Bin"
            className="h-6 w-6"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = "none";
              e.target.parentNode.appendChild(
                document.createElement("span")
              ).textContent = "🗑️";
            }}
          />
        </button>
      </div>
    );
  };

  // Custom render function for investigator actions
  const renderInvestigatorActions = (item, onShowDeleteModal, onEdit) => {
    let statusElement;
    if (
      item.invitation_status === "pending" ||
      item.invitation_status === "sent"
    ) {
      statusElement = <StatusBadge type="invited">Invited</StatusBadge>;
    } else if (item.invitation_status === "joined") {
      statusElement = (
        <StatusBadge
          type="confirm"
          onClick={() => handleConfirmInvitation(item.id, "investigator")}
        >
          Confirm
        </StatusBadge>
      );
    } /* active */ else {
      statusElement = <StatusBadge type="active">Active</StatusBadge>;
    }

    return (
      <div className="flex items-center space-x-2 justify-end">
        {statusElement}
        <button
          onClick={() => onShowDeleteModal(item)}
          className="text-gray-700 hover:text-gray-900 cursor-pointer"
          aria-label="Delete"
        >
          <img
            src="/icons/study/Bin.svg"
            alt="Bin"
            className="h-6 w-6"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = "none";
              e.target.parentNode.appendChild(
                document.createElement("span")
              ).textContent = "🗑️";
            }}
          />
        </button>
      </div>
    );
  };

  return (
    <div
      className={`bg-dashboard-bg1 p-4 sm:p-6 rounded-xl min-w-0 ${
        study.status === "closed" ? "pointer-events-none" : ""
      }`}
    >
      {/* Study Management Section */}
      <h1 className="text-xl mb-2 font-bold">Role Management</h1>
  
      <FormSection title="Study management">
        {/* Make the table area always scrollable horizontally on medium/shared screens */}
        <div className="-mx-4 sm:mx-0 overflow-x-auto">
        <div className="min-w-[1120px] sm:min-w-[1120px] md:min-w-[1180px]">
            <EditableTable
              items={studyManagers}
              columns={studyManagerColumns}
              onEdit={handleEditManager}
              onDelete={handleDeleteManager}
              onReorder={handleReorderManagers}
              emptyMessage="No study managers have been added yet."
              saveModalTitle="Save manager changes"
              saveModalMessage="You are about to save the modifications made to the study managers."
              cancelModalTitle="Discard manager changes"
              cancelModalMessage="You are about to discard all modifications made to the study managers."
              deleteModalTitle="Delete study manager"
              deleteModalMessage="You are about to permanently delete this study manager."
              renderCell={renderManagerCell}
              firstRowEditable={false}
              renderActions={renderManagerActions}
            />
          </div>
        </div>
  
        {/* Add Study Manager Form */}
        <h3 className="text-lg font-semibold mt-6 mb-4">Add study manager</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch">
          <FormInput
            label="Study manager name"
            name="name"
            value={newManager.name}
            onChange={handleManagerInputChange}
            placeholder="Sponsor name, CRO name, ..."
            containerClassName="min-w-0"
            inputClassName="w-full min-w-0"
          />
          <FormInput
            label="Contact name"
            name="contactName"
            value={newManager.contactName}
            onChange={handleManagerInputChange}
            placeholder="First and last name"
            containerClassName="min-w-0"
            inputClassName="w-full min-w-0"
          />
          <FormInput
            label="Email address"
            name="email"
            type="email"
            value={newManager.email}
            onChange={handleManagerInputChange}
            placeholder="name@mail.com"
            containerClassName="min-w-0"
            inputClassName="w-full min-w-0"
          />
          {/* Button row – stays full width on small, right-aligned from md */}
          <div className="md:col-span-3">
            <div className="flex w-full justify-stretch md:justify-end">
              <Button
                onClick={handleAddManager}
                variant="addbutton"
                className="w-full md:w-auto px-4 py-2"
                disabled={isSendingManagerInvitation}
              >
                {isSendingManagerInvitation ? "Sending..." : "Send Invitation"}
              </Button>
            </div>
          </div>
        </div>
      </FormSection>
  
      {/* Investigators Section */}
      <FormSection title="Investigator(s)" className="mt-8">
        <div className="-mx-4 sm:mx-0 overflow-x-auto">
        <div className="min-w-[1120px] sm:min-w-[1120px] md:min-w-[1180px]">
            <EditableTable
              items={investigators}
              columns={investigatorColumns}
              onEdit={handleEditInvestigator}
              onDelete={handleDeleteInvestigator}
              onReorder={handleReorderInvestigators}
              emptyMessage="No investigators have been invited yet. They will appear in the table once added."
              saveModalTitle="Save investigator changes"
              saveModalMessage="You are about to save the modifications made to the investigators."
              cancelModalTitle="Discard investigator changes"
              cancelModalMessage="You are about to discard all modifications made to the investigators."
              deleteModalTitle="Delete investigator"
              deleteModalMessage="You are about to permanently delete this investigator."
              renderCell={renderInvestigatorCell}
              renderActions={renderInvestigatorActions}
            />
          </div>
        </div>
  
        {/* Add Investigator Form */}
        <h3 className="text-lg font-semibold mt-6 mb-4">Send invitation</h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-stretch">
          <FormInput
            label="Investigator name"
            name="name"
            value={newInvestigator.name}
            onChange={handleInvestigatorInputChange}
            placeholder="First and last name"
            containerClassName="min-w-0"
            inputClassName="w-full min-w-0"
          />
          <FormInput
            label="Email address"
            name="email"
            type="email"
            value={newInvestigator.email}
            onChange={handleInvestigatorInputChange}
            placeholder="name@mail.com"
            containerClassName="min-w-0"
            inputClassName="w-full min-w-0"
          />
          <FormInput
            label="Phone number"
            name="phone"
            type="tel"
            value={newInvestigator.phone}
            onChange={handleInvestigatorInputChange}
            placeholder="+12481237654"
            containerClassName="min-w-0"
            inputClassName="w-full min-w-0"
          />
          <div className="min-w-0">
            <label className="block text-sm font-medium text-gray-700 mb-1">Assigned site</label>
            <select
              name="site"
              value={newInvestigator.site}
              onChange={handleInvestigatorInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF] bg-white"
            >
              <option value="">Select</option>
              {sites.map((site) => (
                <option key={site.id} value={site.id}>{site.siteName}</option>
              ))}
            </select>
          </div>
  
          {/* Button row – full width on small, right-aligned from md */}
          <div className="md:col-span-4">
            <div className="flex w-full justify-stretch md:justify-end">
              <Button
                onClick={handleAddInvestigator}
                variant="addbutton"
                className="w-full md:w-auto px-4 py-2"
                disabled={isSendingInvestigatorInvitation}
              >
                {isSendingInvestigatorInvitation ? "Sending..." : "Send Invitation"}
              </Button>
            </div>
          </div>
        </div>
      </FormSection>
    </div>
  );
              }